// @flow

import * as React from "react"
import { injectIntl } from "react-intl"
import { isUndefined } from "lodash"
import { Form, Input } from "antd"

type Props = {
  intl: Object,
  getFieldDecorator: Function,
  required: boolean,
  name: string,
  onBlur?: Function,
  style?: Object,
  initialValue: string,
  onChange?: Function,
  normalize?: Function,
  disabled: boolean,
  label?: string,
  placeholder?: string
}

class EmailFormItem extends React.Component<Props> {
  static defaultProps = {
    required: false,
    name: "email",
    onBlur: () => {},
    disabled: false
  }

  render() {
    const {
      initialValue,
      onChange,
      normalize,
      placeholder,
      label,
      intl: { formatMessage }
    } = this.props
    const fieldLabel = isUndefined(label)
      ? formatMessage({ id: "common.email" })
      : label

    return (
      <Form.Item style={this.props.style} label={fieldLabel}>
        {this.props.getFieldDecorator(this.props.name, {
          initialValue,
          validateTrigger: "onBlur",
          onChange,
          normalize,
          rules: [
            {
              required: this.props.required,
              type: "email",
              message: formatMessage({
                id: "validation.email.valid"
              })
            }
          ]
        })(
          <Input
            onBlur={this.props.onBlur}
            disabled={this.props.disabled}
            placeholder={placeholder}
          />
        )}
      </Form.Item>
    )
  }
}

export default (injectIntl(EmailFormItem): any)
